import script from "./print-difference-report.vue?vue&type=script&setup=true&lang=ts"
export * from "./print-difference-report.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__